import { useNavigate } from "react-router-dom";
import '../../css/NotFound.css'
//Translation
import { useTranslation } from 'react-i18next';

export default function NotFound({ isNavOpen }) {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const goHome = () => navigate('/');

  return (
    <div className={`${isNavOpen ? 'body-squeezed' : 'body'}`}>
      <div className="not-found">
        <h1>{t('notFound.title')}</h1>
        <p>{t('notFound.message')}</p>
        <button
          onClick={goHome}
          className="button-white"
          style={{ marginTop: '1.5rem' }}
        >
          {t('notFound.goHome')}
        </button>
      </div>
    </div>

  )
}